import transportTypes from 'shared/constants/json/transportTypes.json';

export const getChildTransportsBySlug = slug => {
  const id = transportTypes.find(type => type.slug === slug).id;
  return transportTypes.filter(type => type.parents.includes(id));
};

export const getRootTransport = transport => {
  if (!transport) {
    return transport;
  }

  // TODO: recurse
  return transport.parents.length === 0
    ? transport
    : transportTypes.find(t => t.id === transport.parents[0]);
};

export const getRootTransportBySlug = transportSlug =>
  getRootTransport(transportTypes.find(type => type.slug === transportSlug));

export const getRootTransportType = transport => {
  if (!transport) {
    return null;
  } else if (transport.parents && transport.parents.length > 0) {
    return getRootTransportType(transport.parents[0]);
  } else if (transport.slug) {
    return transport;
  }

  return null;
};



// WEBPACK FOOTER //
// ./src/shared/helpers/transportTypes.js